import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Ng2StateDeclaration } from '@uirouter/angular';

@Component({
    template: '<ui-view></ui-view>',
    standalone: false
})
export class InvoiceParentContainerComponent {}

export const InvoiceRoute: Ng2StateDeclaration = {
    // name: 'invoice.**'
    abstract: true,
    name: 'invoice',
    url: '/invoice',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.invoiceModule)
    data: { requiresAuth: true },
    // redirectTo: 'invoice.management',
    component: InvoiceParentContainerComponent
};
